import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70422e8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CustomReports" }
const _hoisted_2 = {
  key: 0,
  class: "content-container"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loading" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "loader" })
], -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "content-container",
  style: {"padding-left":"0","padding-right":"0"}
}
const _hoisted_6 = { class: "top-content" }
const _hoisted_7 = { class: "center-dropdown-table-container" }
const _hoisted_8 = { class: "center-dropdown-table" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Report Selection:", -1))
const _hoisted_10 = ["value"]
const _hoisted_11 = { colspan: "2" }
const _hoisted_12 = { class: "center-buttons" }
const _hoisted_13 = { class: "power-bi" }
const _hoisted_14 = ["src"]

import { Ref, inject, onMounted, onBeforeUnmount, ref } from "vue";
// Services
import { IAPILogger } from "@/interfaces/IAPILogger";
import { GetReportsInGroup, NavigateToPowerBIWorkspace } from "@/services/helpers/CustomReportsHelper"
// Data
import { IReportInGroupDetails } from "@/Interfaces/CustomReports/IGetReportsInGroupResponse";
// Misc
import log from "loglevel";
import { AxiosError } from "axios";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";

const fileName = "CustomReports.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomReports',
  setup(__props) {

document.title = 'Reports - UV';

log.trace("Reports");
const Logger: IAPILogger = inject("Logger")!;

////////////////////////////////////////////////////////////////////////////
// LOGIC
////////////////////////////////////////////////////////////////////////////
// DATA FETCHING
const isLoading = ref(false);
const reportsInGroup: Ref<IReportInGroupDetails[] | undefined> = ref(undefined);
const customReportSelection: Ref<string> = ref("");
const customReportId: Ref<string> = ref("");
const customReportUrl: Ref<string> = ref("");

// Create a ref to store the visibility state
const isPageVisible = ref(true);

// Bind iframe key to reactive property
const iframeKey = ref(0);

// Function to handle visibility change
const handleVisibilityChange = () => {
  if (document.hidden) {
    // Page is not visible
    isPageVisible.value = false;
    log.debug("isPageVisible:", isPageVisible.value);
  } else {
    // Page is visible
    isPageVisible.value = true;
    log.debug("isPageVisible:", isPageVisible.value);
    // iframeKey.value += 1;
    iframeKey.value = 1;
    log.debug("iframeKey:", iframeKey.value);
  }
};

onMounted(async () => {
    log.trace("onMounted()");

    // Add event listener for visibility change
    document.addEventListener('visibilitychange', handleVisibilityChange);

    isLoading.value = true;

    const name = GetReportsInGroup.name;
    const Class = fileName + "/" + name;
    var Message = `Getting reports in group from Power BI API`;

    await GetReportsInGroup()
        .then((reports: IReportInGroupDetails[]) => {
            log.debug("onMounted()\nreports:", reports);
            if (reports) {
                reportsInGroup.value = reports;
                reportsInGroup.value.sort((a: IReportInGroupDetails, b: IReportInGroupDetails) =>
                    a.name.localeCompare(b.name)
                );
                const report: IReportInGroupDetails = reports.at(0)!;
                // const report: IReportInGroupDetails = reports.find((r) => {
                //     r.name.includes("DatabaseTables");
                // }) || reports.at(0)!;
                log.trace("onMounted()\nreport:", report);
                customReportId.value = report.id;
                Logger.LogInformation(Message, Class);

                updateSelection();
            }
        })
        .catch(error => {
            if (error instanceof AxiosError) {
                useNotifierWithErrFormatter().error({error, errorType: "Getting Custom Reports From Power BI"})
            }
            Message = `(Error) ${Message}: ${error instanceof AxiosError ? error : error.message}`;
            log.error(Message);
            Logger.LogError(Message, Class);
        });

    isLoading.value = false;
});

// Remove event listener when the component is unmounted
onBeforeUnmount(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange);
});

async function updateSelection() {
    log.trace("updateSelection()");

    const name = updateSelection.name;
    const Message = `Changed selection to: ${customReportSelection.value}.`;
    const Class = fileName + "/" + name;

    customReportUrl.value = process.env.VUE_APP_POWER_BI_CUSTOM_REPORT_URL_PREFIX! + customReportId.value + process.env.VUE_APP_POWER_BI_CUSTOM_REPORT_URL_SUFFIX!;
    log.debug("updateSelection()\ncustomReportUrl:", customReportUrl.value, "\nid:", customReportId.value);

    Logger.LogInformation(Message, Class);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, [
                      _hoisted_9,
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customReportId).value = $event)),
                        onChange: _cache[1] || (_cache[1] = ($event: any) => (updateSelection())),
                        class: "custom-report-dropdown"
                      }, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reportsInGroup.value, (report) => {
                          return (_openBlock(), _createElementBlock("option", {
                            value: report.id,
                            key: report.name
                          }, _toDisplayString(report.name), 9, _hoisted_10))
                        }), 128))
                      ], 544), [
                        [_vModelSelect, customReportId.value]
                      ])
                    ]),
                    _createElementVNode("td", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("button", {
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(NavigateToPowerBIWorkspace)())),
                          class: "incident-nav-button",
                          title: "Create a new report in PowerBI (3rd party resource opens in new tab)"
                        }, " Create New Report ")
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_openBlock(), _createElementBlock("iframe", {
              title: "CustomReports",
              src: customReportUrl.value,
              frameborder: "0",
              allowFullScreen: "true",
              key: iframeKey.value
            }, null, 8, _hoisted_14))
          ])
        ]))
  ]))
}
}

})